var r=function(r){return r.charAt(0).toUpperCase()+r.slice(1)};export{r as capitalizeFirstLetter};
//# sourceMappingURL=capitalizeFirstLetter.js.map
